<script lang="ts">
    import TopRightCrinkle from "../../widgets/TopRightCrinkle.svelte"
    import ProductConfigurator from "./ProductConfigurator.svelte"
    import ProductExtendableBoxes from "./ProductExtendableBoxes.svelte"
    import ProductImagePreview from "./ProductImagePreview.svelte"
    import ProductSummary from "./ProductSummary.svelte"

    export let product: BKDFProduct
    let previewImages: Image[] = [],
        selectedVariant: BKDFProductVariant | null = null
</script>

<section id="productPage">
    <div class="product-page-wrapper">
        <section class="lefternSide">
            <div class="crinkle">
                <TopRightCrinkle
                    edges="{false}"
                    brightColor="{true}"
                />
            </div>
            <div class="outerWrapper">
                <div class="inner-container">
                    {#if previewImages?.length}
                        <ProductImagePreview previewImages="{previewImages}" />
                    {/if}
                </div>
            </div>
            {#if product}
                <ProductExtendableBoxes product="{product}" />
            {/if}
        </section>
        <section class="righternSide">
            {#if product}
                <ProductSummary
                    product="{product}"
                    productTitleAsHeading="{true}"
                />
                <ProductConfigurator
                    product="{product}"
                    on:colorChange="{(e) => {
                        previewImages = e.detail.previewImages
                    }}"
                    on:variantChange="{(e) => {
                        selectedVariant = e.detail.variant
                        previewImages = e.detail.previewImages
                    }}"
                />{/if}
        </section>
    </div>
</section>

<style lang="less">
    #productPage {
        width: 100%;
        position: relative;
        display: flex;
        padding-bottom: 3rem;

        justify-content: center;
        .product-page-wrapper {
            margin: 0 var(--horizontal-default-margin);
            display: flex;
            width: 100%;
            max-width: var(--normal-max-width);
            flex-direction: row;
            position: relative;

            .lefternSide {
                min-height: 100%;
                width: 0px;
                flex-grow: 2;
                position: relative;
                overflow-x: visible;
                .crinkle {
                    position: sticky;
                    width: calc(100% + 5px);
                    height: 0px;
                    overflow: visible;
                    display: flex;
                    justify-content: flex-end;
                    top: 146px;

                    z-index: 100;
                }
                .outerWrapper {
                    height: min(65vh, 38.25rem);
                    width: 100%;
                    .inner-container {
                        position: absolute;
                        width: 100%;
                        @media (min-width: 1770px) {
                            min-width: calc(100% + (100vw - var(--normal-max-width)) / 2);
                            left: calc(-1 * (100vw - var(--normal-max-width)) / 2);
                        }
                        @media (max-width: 1769px) {
                            left: calc(-1 * var(--horizontal-default-margin));
                            min-width: calc(100% + var(--horizontal-default-margin));
                        }
                    }
                }
            }
            .righternSide {
                width: 0px;
                flex-grow: 1;

                padding-left: 3.6rem;
                position: sticky;
                top: 140px;
                height: fit-content;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
            }
        }
    }
</style>
